/// <reference path="../types.d.ts" />

type PostPromise = {
    timer?: ReturnType<typeof setTimeout>;
    resolve: (data: any) => void;
};

const postPromises: Record<string, PostPromise> = {};
let isInitialized = false;
let origin: string | null = null;
let clientId: string | null = null;
let restParams = '';
let frameData: any;

function parseJson(value: string): any {
    try {
        return JSON.parse(value);
    } catch {
        return undefined;
    }
}

function handleMessage(event: MessageEvent) {
    if (event.origin !== window.location.origin || typeof event.data !== 'string') {
        return;
    }

    const eventData = parseJson(event.data);
    if (!eventData?.uid) {
        return;
    }

    const postPromise = postPromises[eventData.uid];
    if (postPromise) {
        delete postPromises[eventData.uid];

        if (postPromise.timer) {
            clearTimeout(postPromise.timer);
        }

        postPromise.resolve(eventData.data);
    }
}

export function initializeCrowdinIframeContext(): void {
    if (isInitialized) {
        return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    origin = urlParams.get('origin');
    clientId = urlParams.get('client_id');
    restParams = window.location.search;
    frameData = JSON.parse(window.name);

    window.addEventListener('message', handleMessage);
    isInitialized = true;
}

function ensureInitialized(): void {
    if (!isInitialized) {
        initializeCrowdinIframeContext();
    }
}

export function getFrameData(): any {
    ensureInitialized();

    return frameData;
}

export function getPostPromises(): Record<string, PostPromise> {
    ensureInitialized();

    return postPromises;
}

export function showToast(message?: string): void {
    if (message) {
        const toasts = document.querySelector('crowdin-toasts') as any;
        if (toasts && toasts.pushToasts) {
            toasts.pushToasts([message]);
        }
    }
}

export function reloadLocation(): void {
    ensureInitialized();

    window.location.href =
        window.location.protocol + '//' + window.location.host + window.location.pathname + restParams;
}

export function catchRejection(e: any, message?: string): void {
    // session expired
    if (e.code && e.code === 401) {
        reloadLocation();
        return;
    }
    // payment required
    if (e.code && e.code === 402 && window.app?.subscriptionModal.current) {
        if (window.app.subscriptionLink) {
            window.app.subscriptionLink.current = e.message || message;
        }
        window.app.openModal(window.app.subscriptionModal.current);
        return;
    }
    showToast(e.message || message);
}

export function checkResponse(response: Response): Promise<any> {
    return new Promise((resolve, reject) => {
        if (response.status === 204) {
            return resolve(undefined);
        }
        response
            .json()
            .then((res) => {
                if (![200, 201, 202, 304].includes(response.status)) {
                    reject(res);
                } else {
                    if (res.message) {
                        setTimeout(() => showToast(res.message), 100);
                    }
                    resolve(res);
                }
            })
            .catch((e) => {
                reject(e);
            });
    });
}

export function checkOrigin(): Promise<string> {
    ensureInitialized();

    return new Promise((resolve) => {
        AP.getJwtToken((jwtToken) => {
            restParams = `?origin=${origin}&client_id=${clientId}&jwtToken=${jwtToken}`;
            resolve(restParams);
        });
    });
}
